import { DataProtectionNotice, DataProtectionNoticeItem } from '../models/data-protection-notice.model';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit/confirmation-dialog';
import { Language } from '../../../../../common/constants';
import { MatDialogRef } from '@angular/material/dialog';

export class DataProtectionNoticeItemLoad {
  public static readonly type = '[DataProtectionNoticeItem] Load';

  constructor(public payload: number) {}
}

export class DataProtectionNoticeItemSave {
  public static readonly type = '[DataProtectionNoticeItem] Save';

  constructor(public payload: Partial<DataProtectionNoticeItem>) {}
}

export class DataProtectionNoticeItemUpdate {
  public static readonly type = '[DataProtectionNoticeItem] Update';

  constructor(public payload: DataProtectionNotice) {}
}

export class DataProtectionNoticeItemPublish {
  public static readonly type = '[DataProtectionNoticeItem] Publish';

  constructor(public payload: { dpnItemId: number; dialog: MatDialogRef<ConfirmationDialogAfterClosedModel> }) {}
}

export class DataProtectionNoticeItemDelete {
  public static readonly type = '[DataProtectionNoticeItem] Delete';

  constructor(public payload: { dpnItemId: number; dialog: MatDialogRef<ConfirmationDialogAfterClosedModel> }) {}
}

export class DataProtectionNoticeListDelete {
  public static readonly type = '[DataProtectionNoticeList] Delete';

  constructor(public payload: { dpnListId: number; dialog: MatDialogRef<ConfirmationDialogAfterClosedModel> }) {}
}

export class DataProtectionNoticeItemAccept {
  public static readonly type = '[DataProtectionNoticeItem] Accept';

  constructor(
    public payload: {
      isNewsletterSubscriptionAccepted: boolean;
      lang: Language;
    },
  ) {}
}

export class DataProtectionNoticeItemInitialState {
  public static readonly type = '[DataProtectionNoticeItem] Set initial state';
}
